import React from 'react';
import LogoImgUrl from './logo_png.png';

const Logo = (): JSX.Element => (
  <img src={LogoImgUrl} alt="logo" />
);

export default Logo;
